import { render } from "./CrmDealKanbanDealDataModalReportModalQuestionsTextArea.vue.vue?vue&type=template&id=fd845106"
import script from "./CrmDealKanbanDealDataModalReportModalQuestionsTextArea.vue.vue?vue&type=script&lang=js"
export * from "./CrmDealKanbanDealDataModalReportModalQuestionsTextArea.vue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__